export const transformAuthors = (authors) => {
  return authors && authors.length > 0
    ? authors.map((a) => ({ sid: a.sid, name: a.firstName + " " + a.lastName }))
    : [];
};

export const formatAuthors = (authors) => {
  if (!authors?.length) return "";
  return authors
    .map((a) => [a.firstName, a.lastName].filter(Boolean).join(" "))
    .join(", ");
};
